/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { latestInterviewBookingDataStatusSchema } from './LatestInterviewBookingDataStatusSchema'

export const latestInterviewBookingDataSchema = z.object({
	status: latestInterviewBookingDataStatusSchema,
	candidateAttended: z.boolean().nullable(),
	scheduledAt: z.iso.datetime(),
})

export type LatestInterviewBookingDataSchema = z.infer<typeof latestInterviewBookingDataSchema>
